import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { driverModule } from '../../../../../../modules/information/driver';
import { ExcelExportService } from 'src/app/Services/excel.service';
declare const Swal;

@Component({
  selector: 'view-driver',
  templateUrl: './view-driver.component.html',
  styleUrls: ['./view-driver.component.css']
})


export class ViewDriverComponent {
  public driverExcelColumns = [
    { key: 'name', label: 'Driver Name', required: true, sampleValue: 'Ravi Kumar' },
    { key: 'mobile', label: 'Mobile No', required: true, sampleValue: '9876543210' },
    { key: 'branch', label: 'Branch', required: true, sampleValue: 'Main Branch' },
    { key: 'shift', label: 'Shift', required: true, sampleValue: 'General' },
    { key: 'status', label: 'Status (Active/Inactive)', required: true, sampleValue: 'Active' },
    { key: 'licenceNo', label: 'Licence No', required: true, sampleValue: 'TN0120230001234' },
    { key: 'licenceExpiry', label: 'Licence Expiry', required: true, sampleValue: 'DD/MM/YYYY' },
    { key: 'dob', label: 'Date of Birth', required: true, sampleValue: 'DD/MM/YYYY' },
    { key: 'emergencyContact', label: 'Emergency Contact', required: true, sampleValue: '9876543211' },
    { key: 'bloodGroup', label: 'Blood Group', required: false, sampleValue: 'B+' },
    { key: 'address', label: 'Address', required: true, sampleValue: '12 MG Road' },
    { key: 'city', label: 'City', required: true, sampleValue: 'Bengaluru' },
    { key: 'state', label: 'State', required: true, sampleValue: 'Karnataka' },
    { key: 'pincode', label: 'Pincode', required: true, sampleValue: '560001' }
  ];


  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };

  public xlFileName: any = '';
  public enableFileName: boolean = false;
  public generalSetting: boolean = false;

  public closeExlUploadAlert: boolean = true;
  public exlUploadPopup: boolean = true;
  public exlUploadRes: any;
  // public exlUploadTable = [
  //   { key: 'name', display: 'Driver Name' },
  //   { key: 'mobile', display: 'Mobile No' },
  //   { key: 'branch', display: 'Branch', config: { isBranch: true, } },
  //   { key: 'shift', display: 'Shift', config: { isShift: true, } },
  // ]
  public exlUploadTable = [
  { key: 'name', display: 'Driver Name' },
  { key: 'mobile', display: 'Mobile No' },
  { key: 'branch', display: 'Branch' },
  { key: 'shift', display: 'Shift' },
  { key: 'licenceNo', display: 'Licence No' },
  { key: 'licenceExpiry', display: 'Licence Expiry' },
  { key: 'dob', display: 'Date of Birth' },
  { key: 'emergencyContact', display: 'Emergency Contact' },
  { key: 'bloodGroup', display: 'Blood Group' },
  { key: 'city', display: 'City' },
];
  public datacount: any;
  driExcelData: any = [];
  public excelData = {};

  constructor(

    public router: Router,
    public api: ApiService,
    private location: Location,
    public storage: StorageService,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public comService: CommonServices,
    public excel: ExcelExportService,
  ) {
    this.orgID = this.storage.get('userInfo').orgID;
    this.userType = this.storage.get('userType');
    this.userData = this.storage.get('vendorViewData');
    let vendorName = this.storage.get('vendorID_orgID')['vendorName'];
    let userInfo = this.storage.get('userInfo');
    if (userInfo?.general?.event == true) this.generalSetting = true;

    this.route.paramMap.subscribe((params: any) => {
      this.vendorID = params.params.vendorID;
      if (vendorName) {
        vendorName = this.comService.strTruncate(vendorName, 13);
        this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
      } else {
        this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
      }
      this.breadcrumbData['Drivers'] = "";
    });

  }
  public driverInfo: any = driverModule;
  public driverInformation: any;
  public driverData: any;
  userType: string;
  userData: any;
  orgID: string;

  vendorID: string;
  public values: any = [];
  public editForm: boolean;
  public filterTable: boolean = true;
  public enableTable: boolean = false;
  public cols = [
    { key: '#', display: '#' },
    { key: 'name', subKey: 'compRating', display: 'Driver name', config: { isComplaint: true }, headerConfig: { isDefault: true } },
    { key: 'mobile', display: 'Mobile no', headerConfig: { isDefault: true } },
    {
      key: 'dob', display: 'DOB',
      config: {
        isDate: true,
        format: 'dd MMM YYYY'
      },
      headerConfig: { isDefault: true },
    }, {
      key: 'licenceNo', display: 'Licence no', headerConfig: { isDefault: true },
      config: {
        isUppercase: true,
      }
    }, {
      key: 'licenceExpiry', display: 'Licence expiry date', headerConfig: { isDefault: true },
      config: {
        isDate: true,
        format: 'dd MMM YYYY',
        isBadge: true,
        badgeData: [{
          key: 'expiryTrue', name: 'E', badgeClass: "badge-danger", title: 'Licence expiried'
        }],
      }
    },
    { key: 'city', display: 'City' },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View' },
          { display: 'Update', color: 'primary', icon: 'Edit', class: 'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' }
        ]
      }
    }
  ];
  /* Pagination */
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }

  searchChangeObserver: any;
  public enableFilter: boolean = false;
  public searchInputValue: any = '';


  ngOnInit() {
    if (this.userType != 'transport_manager') {
      this.router.navigate(['/organization/transport-manager/login']);
    }
    setTimeout(() => { this.getListDriver(); }, 1000);
  }

  submitted(e: any) {
    console.log(e);
  }




  onActionHandler(e: any) {
    const data = e.data;
    let view = 'view'
    if (e.action.display.toLowerCase() == 'update') {
      this.router.navigate(['/organization/transport-manager/information/driver/edit-driver', e.data.vendorID, e.data.driverID]);
      // for (let f of this.driverInfo) {
      //   let name = f['name'];
      //   let value = '';
      //   if (f.type == 'dropdown') {
      //     let val = data[name].split(',');
      //     let temp = [], str = [];
      //     val.map(item => { temp.push({ value: val, name: val }); str.push(item) });
      //     f.selected = temp;
      //     f['value'] = str.join(',');
      //   } else if (f.type == 'checkbox') {
      //     let spStr = data[name].split(',')
      //     for (let op of f.options) {
      //       if (spStr.indexOf(op.value) !== -1) op.selected = true;
      //     }
      //   } else {
      //     if (name == 'email') value = 'emailID';
      //     else value = name;
      //     f['value'] = data[value];
      //   }
      // }
      // this.editForm = true;
    } else if (e.action.display.toLowerCase() == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteDriverData(e);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.router.navigate(['/organization/transport-manager/information/driver/preview-driver', e.data.vendorID, e.data.driverID, view]);
    }
  }
  deleteDriverData(e?) {
    const obj = {
      orgID: e.data.orgID,
      vendorID: e.data.vendorID,
      driverID: e.data.driverID,
    };
    this.api.transportManagerDriverDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getListDriver(1, this.paginationData.limit, this.searchInputValue);
      } else {
        Swal.fire({
          icon: 'error',
          title: res['status'],
          text: res['message'],
        });
        // this.swal.swalFunction(res.status, res.status, res.message,2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }


  submitForm(e: any) {
    if (e == 0) { this.editForm = false; } else {
      console.log(e);
    }
  }


  getListDriver(page = 1, limit = 10, driverName?) {
    this.enableTable = false;
    const obj = {
      orgID: this.orgID == null ? this.storage.get('vendorsIdOrgId').orgID : this.orgID,
      vendorID: this.vendorID == null ? this.storage.get('vendorsIdOrgId').vendorID : this.vendorID,
      page: page,
      limit: limit,
    };
    if (driverName) obj['name'] = driverName;

    this.api.transportManagerDriverList(obj).then((res: any) => {
      if (res.status == 'success') {

        // this.driverData = res.data;
        // let data
        // for(let i=0;i< res.data.length;i++){
        //   console.log( res.data[i].mobile.substr(7,10))
        //   data = res.data
        //   if(res.data[i].mobile){
        //      data[i].mobile.substr(7,10)
        //      this.driverData.push(data)
        //   }

        // }
        this.enableFilter = true;
        this.processTableData(res.data);
        this.processPagination(res, obj);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  processPagination(data, req) {
    this.enableTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.enableTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    this.datacount = total;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getListDriver(data.page, data.limit, this.searchInputValue);
  }

  processTableData(data) {
    this.enableTable = false;
    this.driverData = data.map((driver) => {
      let obj = {
        name: driver['name'] ? driver['name'] : '',
        licenceNo: driver['licenceNo'] ? driver['licenceNo'] : '',
        mobile: driver['mobile'] ? driver['mobile'] : '',
        dob: driver['dob'] ? driver['dob'] : '',
        city: driver['city'] ? driver['city'] : '',
        driverID: driver['driverID'] ? driver['driverID'] : '',
        vendorID: driver['vendorID'],
        compRating: (driver['compRating'] == 0 || driver['compRating']) ? driver['compRating'] : '',
        licenceExpiry: driver['licenceExpiry'] ? driver['licenceExpiry'] : '',
      }
      if (driver['licenceExpiry'] && this.isExpired(driver['licenceExpiry']) == true) {
        obj['expiryTrue'] = this.isExpired(driver['licenceExpiry']);
      }
      return obj;
    });
    setTimeout(() => { this.enableTable = true; }, 100);
  }
  isExpired(timestamp) {
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    let currentD = currentDate.getTime();
    return timestamp < currentD; // Check if the timestamp is less than the current time
  }

  // search
  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getListDriver(1, this.paginationData.limit, term);
          else if (String(term).length >= 3) this.getListDriver(1, this.paginationData.limit, term);
        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  downloadTemplate() {
    const templateRow = [];
    const columnWidths = [];
    const headerCells = [];

    this.driverExcelColumns.forEach((column, index) => {
      templateRow.push(column.sampleValue || '');
      columnWidths.push({ colNo: index + 1, width: Math.max(column.label.length + 4, 18) });
      headerCells.push({
        cell: `${String.fromCharCode(65 + index)}1`,
        value: column.required ? {
          richText: [
            { text: column.label, font: { bold: true, color: { argb: 'FF000000' } } },
            { text: ' *', font: { bold: true, color: { argb: 'FFFF0000' } } }
          ]
        } : column.label,
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD9D9D9' }
        },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        },
        alignment: {
          vertical: 'middle',
          horizontal: 'center'
        }
      });
    });

    this.excel.generateExcel({
      Template: {
        data: {
          data: [],
          columWith: columnWidths
        },
        customizedData: [
          {
            value: this.driverExcelColumns.map((column) => column.label),
            cellConfig: {
              cells: headerCells
            }
          },
          {
            value: templateRow,
            border: {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            }
          }
        ]
      }
    }, 'Driver_Template.xlsx');
  }

  uploadExcelFile() {
    document.getElementById('driverExcelUpload').click();
  }

  uploadDriver(event) {
    this.xlFileName = event.target.files[0].name;
    this.enableFileName = true;
    let apiObj = {
      vendorID: this.vendorID
    };
    let url = 'organization/excel/addDriver';
    this.api.xlsxFileUpload(apiObj, url, 'driverExcelUpload', (res: any) => {
      if ((res.responseJSON.exitsData && res.responseJSON.exitsData != {}) || (res.responseJSON.validationFails && res.responseJSON.validationFails != {})) {
        this.exlUploadRes = res.responseJSON;
        this.closeExlUploadAlert = false;
      }
      else if (res.responseJSON.status == 'success' && res.responseJSON.message) {
        this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 5000);

      }
      else if (res.responseJSON.status == 'failure') {
        this.swal.swalFunction('warning', res.responseJSON.status, "Warning", 10000);
      }
      let doc: any = document.getElementById('driverExcelUpload');
      doc.value = '';

    });
  }
  downloadXlFile() {
    this.api.transportMangerDriverListExcel({ "vendorID": this.vendorID }).then((res: any) => {
      if (res.status == 'success') {
        if (res.data.length > 0) {
          this.driExcelData = res.data;
          this.exportToExcel()
        } else {
          this.swal.swalFunction('Info', '', 'No data found', 5000)
        }
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  private formatReportText(value: any, titleCase = false) {
    if (value === null || value === undefined || value === '') return '---';
    const normalizedValue = Array.isArray(value) ? value.join(', ') : String(value);
    return titleCase ? this.comService.convertTitleCase(normalizedValue) : normalizedValue;
  }

  private formatStatus(value: any) {
    if (value === true || value === 1 || value === '1' || value === 'true') return 'Active';
    if (value === false || value === 0 || value === '0' || value === 'false') return 'Inactive';
    return this.formatReportText(value);
  }


  async exportToExcel() {
    this.excelData = {};
    let data = [];
    let serialNo = 1;
    const driverReportColumns = [
      { header: 'S No', width: 10 },
      { header: 'Driver Name', width: 22 },
      { header: 'Mobile Number', width: 18 },
      { header: 'Branch', width: 20 },
      { header: 'Shift', width: 20 },
      { header: 'Status', width: 14 },
      { header: 'Licence No', width: 20 },
      { header: 'Licence Expiry', width: 18 },
      { header: 'Date Of Birth', width: 18 },
      { header: 'Emergency Contact', width: 20 },
      { header: 'Blood Group', width: 16 },
      { header: 'Address', width: 28 },
      { header: 'City', width: 18 },
      { header: 'State', width: 18 },
      { header: 'Country', width: 18 },
      { header: 'Pincode', width: 14 }
    ];
    for (let i = 0; i < this.driExcelData.length; i++) {
      let item = this.driExcelData[i];
      try {
        let res = {
          value: [
            serialNo++,
            this.formatReportText(item.name, true),
            this.formatReportText(item.mobile),
            this.formatReportText(item.branch, true),
            this.formatReportText(item.shift, true),
            this.formatStatus(item.isActive),
            this.formatReportText(item.licenceNo),
            item.licenceExpiry ? this.comService.timestampToDate(item.licenceExpiry, 'DMY') : '---',
            item.dob ? this.comService.timestampToDate(item.dob, 'DMY') : '---',
            this.formatReportText(item.emergencyContact),
            this.formatReportText(item.bloodGroup, true),
            this.formatReportText(item.address),
            this.formatReportText(item.city, true),
            this.formatReportText(item.state, true),
            this.formatReportText(item.country ? item.country : 'India', true),
            this.formatReportText(item.pincode),
          ],

          border: {
            right: { style: 'thin' }, bottom: { style: 'thin' },
          },
        };
        data.push(res);


      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = String.fromCharCode(64 + driverReportColumns.length);
      let customizedData = [];
      let titleRow = {
        value: ['Driver master report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);
      rowCount = rowCount + 2;

      let headerRow =
      {
        value: driverReportColumns.map((column) => column.header),
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = 'Driver master report'

      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: driverReportColumns.map((column, index) => ({ colNo: index + 1, width: column.width })),
        }
      }
      this.downloadExlReport('Driver master report');
    }
  }


  downloadExlReport(data: string) {
    this.excel.generateExcel(this.excelData, data + new Date().getTime() + '.xlsx');
  }

}
